import React, {Component} from 'react';
import {Grid, Row, Col} from "react-bootstrap";
import TopBreadcumb from "../../../../componentsTopsa/breadcrumbs/TopBreadcumb";
import SubHeader from "../../../../shared/sidebar/SubHeader";
import SidebarComponent from "../../../../shared/sidebar/SidebarComponent";
import Links from "../../../../utilities/linksConfig/Links";
import ReactNotify from 'react-notify';
import DefinicjeService from "../definicjeTras/DefinicjeService";
import PrzystankiService from "../przystanki/PrzystankiService";
import TrasyService from "../trasy/TrasyService";
import DefinicjeTable from "./components/DefinicjeTable";
import TopIf from "../../../../componentsTopsa/if/TopIf";
import KonfiguracjaHeader from "../../../../shared/headers/KonfiguracjaHeader";
import DefiicjeForm from "./components/DefiicjeForm";
import utilitiesTopSelect from "../../../../utilities/utilitiesTopSelect";

export default class DefinicjeContainer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            definicje: [],
            przystanki: [],
            przystankiTS:{},
            trasy: [],
            trasyTS:[],
            definicja: null,
            pokazFormularz: false,
            wlaczSzukanie: true,
        };
        this.pobierzDefinicje = this.pobierzDefinicje.bind(this);
        this.pobierzPrzystanki = this.pobierzPrzystanki.bind(this);
        this.pobierzTrasy = this.pobierzTrasy.bind(this);
        this.pokazFormularz = this.pokazFormularz.bind(this);
        this.zamknijFormularz = this.zamknijFormularz.bind(this);
        this.onClickEdytuj = this.onClickEdytuj.bind(this);
        this.onClickUsun = this.onClickUsun.bind(this);
        this.onClickZapisz = this.onClickZapisz.bind(this);
    }

    componentDidMount() {
        this.pobierzDefinicje();
        this.pobierzPrzystanki();
        this.pobierzTrasy();
    }

    pobierzDefinicje() {
        DefinicjeService.getDefinicje().then(function (response) {
            this.setState({definicje: response.data.content})
        }.bind(this))
    }

    pobierzPrzystanki() {
        PrzystankiService.getPrzystanki().then(function (response) {
            this.setState({przystanki: response.data.content, przystankiTS: utilitiesTopSelect.changeTabOfObjectsToSimpleObject(response.data.content,"idPr",'nazMi','nazPr')});
        }.bind(this))
    }

    pobierzTrasy() {
        TrasyService.getTrasy().then(function (response) {
            this.setState({trasy: response.data.content, trasyTS: utilitiesTopSelect.changeTabOfObjectsToSimpleObject(response.data.content,"idTr",'kodTrasy','nazTr')})
        }.bind(this))
    }

    pokazFormularz() {
        this.setState({pokazFormularz: true})
    }

    zamknijFormularz() {
        this.setState({pokazFormularz: false, definicja: null})
    }

    onClickEdytuj(obj) {
        this.pokazFormularz();
        this.setState({definicja: obj})
    }

    onClickUsun(obj) {

        let trasa = this.state.trasy.find(t => t.idTr === obj.idTr)
        let przystanek = this.state.przystanki.find(p => p.idPr === obj.idPr)

        if (Boolean(trasa) && Boolean(przystanek)) {
            if (window.confirm('Czy usunąc definicję na trasie: ' + trasa.nazTr + ' z przystankiem: ' + przystanek.nazPr)) {
                DefinicjeService.deleteDefinicja(obj.idTd).then(function (response) {
                    if (response.status < 300) {
                        this.refs.notificator.success("Pomyślnie usunięto definicję", "", 3000);
                        this.pobierzDefinicje();
                    }
                    else {
                        this.refs.notificator.error("Wystąpił błąd podczas usuwania definicji ", "", 3000);
                    }
                }.bind(this))
            }
        }
    }

    onClickZapisz(obj, czyEdycja) {
        if (czyEdycja) {
            DefinicjeService.editDefinicja(this.state.definicja.idTd, obj).then(function (response) {
                if (response.status < 300) {
                    this.refs.notificator.success("Pomyślnie edytowano definicję", "", 3000);
                    this.pobierzDefinicje();
                }
                else {
                    this.refs.notificator.error("Wystąpił błąd podczas edycjii definicji ", "", 3000);
                }
            }.bind(this))

        }
        else {
            DefinicjeService.addDefinicja(obj).then(function (response) {
                if (response.status < 300) {
                    this.refs.notificator.success("Pomyślnie dodano definicję", "", 3000);
                    this.pobierzDefinicje();
                }
                else {
                    this.refs.notificator.error("Wystąpił błąd podczas dodawania definicji ", "", 3000);
                }
            }.bind(this))
        }
        this.zamknijFormularz();

    }

    render() {

        return (
            <SidebarComponent links={Links.getKonfiguracjaLinks} currentLink={this.props.match.path} history={this.props.history}
                              collapsedLinks={this.props.collapsedLinks}
                              handleClickToogleSidebar={(module) => this.props.handleClickToogleSidebar(module)}>
                <Grid fluid={true} id={'DefinicjeTrasContainer'}>
                    <ReactNotify ref='notificator'/>
                    <Row>
                        <Col sm={12}>
                            <div id="subheader">
                                <TopBreadcumb links={[{addressUrl: '/konfiguracja', text: 'Konfiguracja'}, {
                                    addressUrl: '/konfiguracja/zarzadzanie-trasami',
                                    text: 'Zarządzanie trasami'
                                }, {addressUrl: '/konfiguracja/zarzadzanie-trasami/definicje', text: 'Definicje'}]}/>
                                <SubHeader currentLink={this.props.match.path} obecnyKalendarz={this.props.obecnyKalendarz}
                                           history={this.props.history}/>
                            </div>
                        </Col>
                        <Col sm={12}>
                            <TopIf isTrue={!Boolean(this.state.pokazFormularz)}>
                                <KonfiguracjaHeader pokazFormularz={this.pokazFormularz}
                                                    tekstDodaj={'Dodaj definicję'}
                                                    pokazButtonSzukaj={false}
                                />
                            </TopIf>
                            <TopIf isTrue={Boolean(this.state.pokazFormularz)}>
                                <DefiicjeForm handleClickZapisz={this.onClickZapisz}
                                              handleClickAnuluj={this.zamknijFormularz}
                                              definicja={this.state.definicja}
                                              trasy={this.state.trasy}
                                              przystanki={this.state.przystanki}
                                />
                            </TopIf>
                            <DefinicjeTable data={this.state.definicje}
                                            przystanki={this.state.przystanki}
                                            trasy={this.state.trasy}
                                            wlaczSzukanie={this.state.wlaczSzukanie}
                                            handleEdytuj={this.onClickEdytuj}
                                            handleUsun={this.onClickUsun}
                                            przystankiTS={this.state.przystankiTS}
                                            trasyTS={this.state.trasyTS}
                            />
                        </Col>
                    </Row>
                </Grid>
            </SidebarComponent>
        );
    }
}




// WEBPACK FOOTER //
// ./src/modules/konfiguracja/trasyConfig/defiicje/DefinicjeContainer.js